import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// HR DASHBOARD SUMMARY API
// RoleId/UserId drive backend CC-scoping: for roles with ApplicableForCC='Yes',
// results are restricted to the cost centers assigned to this user in UserCostCenters.
// ==============================================

export const getHRDashboardSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetHRDashboardSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Drill-down list behind a dashboard tile — Type: ContractExpiring | NearingRetirement |
// NearingPF58 | OnLeaveToday | ThisMonthJoinee | OneYearCompletion
export const getHRDashboardDetailList = async ({ type, roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetHRDashboardDetailList`,
            { params: { Type: type, RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Administration dashboard headcount tiles — { StaffHeadcount, LabourHeadcount }, same
// RoleId/UserId CC-scoping as the HR summary.
export const getAdminDashboardSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetAdminDashboardSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
